import React, { useEffect, useRef } from "react";
import Parallax from "parallax-js";
import Lottie from 'lottie-react';
import circleAnimation from '../../lottie/circle-dashed-pulse.json';

const AboutImageSection = ({ sceneRef, lottieRef, circleAnimation }) => {
  return (
    <div className="w-full about-thumbnil-area">
      <div
        data-aos="fade-right"
        className="xl:absolute relative lg:-left-16 md:-left-8 left-0 top-0 lg:w-[682px] md:w-full w-full md:scale-75 lg:scale-90 xl:scale-100"
      >
        <div className="hidden lg:block">
          <div ref={sceneRef} id="about-shape-mouse-anim">
            <div data-depth="0.20" className="layer">
              <div
                data-aos="fade-right"
                className="hidden thumbnil-wrapper md:block relative"
              >
                <div className="absolute inset-0 z-0 scale-[1.1] opacity-10 transform -translate-x-[9%] -translate-y-1/5">
                  <div className="w-full h-full md:scale-75 lg:scale-90 xl:scale-100">
                    <Lottie
                      lottieRef={lottieRef}
                      animationData={circleAnimation}
                      loop={true}
                      autoplay={true}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                </div>
                <img
                  src={require("../../assets/images/home-one-about-thumb-shape.webp")}
                  alt=""
                  className="relative z-10 md:max-w-full"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-right"
          className="left-0 w-full thumbnil-main lg:absolute -bottom-16 relative"
        >
          <div className="flex justify-center w-full">
            <div className="rounded-[10px] sm:rounded-[20px] overflow-hidden xl:w-[360px] lg:w-[300px] md:w-[350px] translate-x-0 md:translate-x-9 lg:translate-x-0 lg:-right-0  w-full h-auto   md:aspect-[360/525]">
              <img
                src={require("../../assets/images/team.jpg")}
                alt=""
                className="w-full h-full object-cover object-[45%_center]"
              />
            </div>
          </div>
        </div>
        <div className="w-full lg:block hidden absolute left-0 top-0 h-[550px] md:scale-75 lg:scale-90 xl:scale-100">
          <div
            ref={sceneRef}
            id="home-one-about-mouse-anim"
            className="h-full"
          >
            <div
              className="absolute layer"
              data-depth="0.30"
            >
              <div
                data-aos="fade-left"
                data-aos-delay="100"
                className="inline-block h-fit px-[20px] py-2.5 bg-yellow text-pone shadow-style-one text-black rounded-full rounded-bl-none md:text-xs lg:text-sm xl:text-base"
              >
                Innovation Methodology
              </div>
            </div>
            <div
              className="absolute layer"
              data-depth="0.40"
            >
              <div
                data-aos="fade-right"
                data-aos-delay="150"
                className="inline-block h-fit px-[50px] py-2.5 bg-yellow text-pone shadow-style-one text-black rounded-full rounded-bl-none md:text-xs lg:text-sm xl:text-base"
              >
                Client-centric approach
              </div>
            </div>
            <div
              className="absolute layer"
              data-depth="0.25"
            >
              <div className="md:relative">
                <div
                  data-aos="fade-up"
                  data-aos-delay="250"
                  className="inline-block h-fit px-[30px] py-2.5 bg-yellow text-pone shadow-style-one text-black rounded-full rounded-br-none md:text-xs lg:text-sm xl:text-base md:relative md:left-[-20%] lg:left-0"
                >
                  <span className="font-semibold text-nowrap">
                    Leading Edge AI
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AboutArticleSection = () => {
  return (
    <div className="about-article-area xl:pt-[100px] lg:pt-[80px] md:pt-[60px] sm:pt-[80px] pt-[100px]">
      <span className="mb-8 section-title-top-tag">What Makes Us Different</span>
      <h2 className="md:text-48 text-34 font-semibold text-main-black mb-[30px] md:w-[90%] w-full xl:w-full lg:text-42 md:text-36">
        We Start With You
      </h2>
      <p className="text-paragraph mb-[50px] md:text-sm lg:text-base leading-relaxed">
        Your journey to uncover big savings and competitive advantages is unique. Private or public LLM? Build or Buy? Deterministic or non-deterministic? You need a top-tier partner that understands your business needs, and finds the shortest path to return on investment. <br></br><br></br> Informulate applies innovation methodology and deep technical knowledge to deliver AI solutions that create competitive  advantages.
      </p>
    </div>
  );
};

export default function AboutSection() {
  const sceneRef = useRef(null);
  const lottieRef = useRef();

  useEffect(() => {
    if (sceneRef.current) {
      const parallaxInstance = new Parallax(sceneRef.current);

      // Cleanup the parallax instance on component unmount
      return () => {
        parallaxInstance.disable();
      };
    }
  }, []);

  useEffect(() => {
    if (lottieRef.current) {
      // Set animation speed to half
      lottieRef.current.setSpeed(0.3);
    }
  }, []);

  return (
    <section className="pb-[200px]">
      <div className="about-wrapper w-full xl:pt-[200px] md:pt-[80px] sm:pt-[50px] md:pb-[200px] sm:pb-[0px]">
        <div className="mx-auto theme-container">
          <div className="w-full grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 xl:gap-[130px] lg:gap-[80px] md:gap-[40px] gap-10 relative">
            <AboutImageSection
              sceneRef={sceneRef}
              lottieRef={lottieRef}
              circleAnimation={circleAnimation}
            />
            <AboutArticleSection />
          </div>
        </div>
      </div>
    </section>
  );
}
